import { useTitleOptions } from 'components/Wizards/MultiStepBlogPostWizard/TitleOptionsProvider'
import { useMutationWithErrorModal } from 'components/Wizards/MultiStepBlogPostWizard/useMutationWithErrorModal'

interface Props {
  onCancel?: () => void
}

export const useGenerateTitleOptions = ({ onCancel }: Props) => {
  const { generateTitleOptions } = useTitleOptions()

  return useMutationWithErrorModal(generateTitleOptions, { onCancel })
}
